<highcharts-chart *ngIf="data?.sites?.length"
                  [Highcharts]="Highcharts"
                  [options]="chartOptions!"
                  (chartInstance)="chartInstance = $event"
                  [className]="'distribution-chart'"
></highcharts-chart>
<app-loader *ngIf="loading"></app-loader>
<app-no-widget-data *ngIf="!data?.sites?.length && !loading"></app-no-widget-data>

